module.exports = "/images/Artboard9.png?6a35eab3ee5544126880723fefb336c4";